import { originalModal } from './modal.js';

export const loadingPopUp = () => {
  const { openModal, closeModal } = originalModal();
  function shouldShowModal() {
    const lastClosed = localStorage.getItem('modalClosedAt');

    if (!lastClosed) return true;

    const now = Date.now();
    const last = parseInt(lastClosed, 10);
    const hours24 = 24 * 60 * 60 * 1000;

    return now - last > hours24;
  }

  // ページロード時の処理
  window.addEventListener('DOMContentLoaded', () => {
    const myModalElement = document.getElementById('loadingModal');
    // トップページのみ表示
    if (location.pathname === '/' && shouldShowModal()) {
      openModal(myModalElement);
    }

    // 閉じるボタンにイベントリスナーをつける
    const closeButtons = document.querySelectorAll('[data-close]');
    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        closeModal(myModalElement, 'fade-out', true, () => {
          localStorage.setItem('modalClosedAt', Date.now().toString());
        });
      });
    });
  });
};
